"use client";
import type { IUSPBannerProps } from "@components/ui/USPbanner/USPbanner";
import { activeSiteConfig } from "@config/site/site-config";
import type { ISiteSettings } from "@contentful-api/types/contentful";
import { Container, type ContainerProps } from "@ui/components/layout/container/Container";
import { useLocale } from "next-intl";
import dynamic from "next/dynamic";
import { Footer, type FooterProps } from "./footer/Footer";
import { Navigation } from "./navigation/Navigation";

const USPbanner = dynamic(() =>
    import("@components/ui/USPbanner/USPbanner").then((mod) => mod.USPbanner)
);

export interface LayoutProps {
    siteSettings: ISiteSettings;
    children: React.ReactNode;
    containerProps?: ContainerProps;
    bannerProps?: Partial<IUSPBannerProps>;
    footerProps?: Partial<FooterProps>;
}

export function Layout({
    siteSettings,
    children,
    containerProps,
    bannerProps,
    footerProps,
}: LayoutProps) {
    const locale = useLocale();

    return (
        <Container px={0} maxW="unset" {...containerProps}>
            {activeSiteConfig?.onKlarnaSiteMessaging && (
                <klarna-placement
                    data-key="top-strip-promotion-auto-size"
                    data-locale={locale}
                    data-purchase-amount="0"
                />
            )}
            {siteSettings?.fields?.uspBanner && (
                <USPbanner uspBanner={siteSettings?.fields?.uspBanner} {...bannerProps} />
            )}
            <Navigation navigation={siteSettings?.fields?.mainNavigation} />
            {children}
            <Footer
                newsletterPolicy={siteSettings?.fields?.eccoNewsletter}
                footerData={siteSettings?.fields?.footer}
                {...footerProps}
            />
        </Container>
    );
}

export default Layout;
